/* eslint-disable react/prop-types */
import React, {Component} from 'react';
import {
    EditButton, FormDataConsumer, FunctionField, Show, Tab, TabbedShowLayout, TextField, translate
} from 'react-admin';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ReactHtmlParser from 'react-html-parser';
import CardActions from '@material-ui/core/CardActions';

import FieldGroup from '~components/FieldGroup';
import ShowCustomActions from '~components/ShowCustomActions';

import styles from './styles';

import './styles.scss';

const names = items => (items || []).map(item => item.name).join(', ');

const VolverButton = props => (
    <>
        <Button style={styles.volverButton} onClick={props.onVolverClick}>
            <svg style={styles.chevron} viewBox="0 0 32 32" className="icon icon-chevron-left" viewBox="0 0 32 32">
                <path
                    fill="#3f51b5"
                    d="M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z"
                />
            </svg>
            Volver
        </Button>
    </>
);

// eslint-disable-next-line react/no-multi-comp
const ShowProjectButton = props => (
    <Button style={styles.showButton} onClick={props.onShowProjectClick}>
        <svg style={styles.mostrarSvg} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            <g>
                <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
            </g>
        </svg>
        Mostrar
    </Button>
);

// eslint-disable-next-line react/no-multi-comp
const ILAT_FE_URL = process.env.REACT_APP_ILAT_FE_URL?.endsWith('/') ? process.env.REACT_APP_ILAT_FE_URL : `${process.env.REACT_APP_ILAT_FE_URL}/`;

const ShowActions = ({basePath, data, resource, permissions, translate: t}) => (
    <CardActions style={styles.cardActionStyle}>
        <EditButton basePath={basePath} record={data}/>
        <ShowCustomActions
            basePath={basePath}
            data={data}
            resource={resource}
            permissions={permissions}
            translate={t}
        />
        <ShowProjectButton
            onShowProjectClick={() => {
                const url = `${ILAT_FE_URL}projects/${data && data.code}/show`;
                window.open(url, '_blank');
            }}
        />
    </CardActions>
);

// eslint-disable-next-line react/no-multi-comp
class AccionShow extends Component {
    handleVolverClick = () => {
        // eslint-disable-next-line react/prop-types
        this.props.history.push('/actions');
    };

    render() {
        const { permissions, translate } = this.props;
        return (
            <>
                <VolverButton onVolverClick={this.handleVolverClick}/>
                <Show actions={<ShowActions permissions={permissions} translate={translate}/>} {...this.props}>
                    <TabbedShowLayout>
                        <Tab label="acción">
                            <FieldGroup
                                label="fieldGroups.projectInformation"
                                formClassName={this.props.classes.borderBottom}
                                show
                            >
                                <TextField source="code" label="Código"/>
                                <TextField source="name" label="Nombre"/>
                                <FunctionField label="Territorios" render={record => names(record.territories)}/>
                                <TextField source="countries_formatted" label="Países"/>
                                <FunctionField label="Temas" render={record => names(record.themes)}/>
                                <FunctionField label="Subtemas" render={record => names(record.subthemes)}/>
                                <br/>

                                <label className="field-label">Objetivos</label>
                                <FormDataConsumer>
                                    {({formData}) => <span
                                        className="field-value">{ReactHtmlParser(formData?.goal)}</span>}
                                </FormDataConsumer>
                                <br/>

                                <label className="field-label">Descripción</label>
                                <FormDataConsumer>
                                    {({formData}) => (
                                        <span className="field-value">{ReactHtmlParser(formData?.description)}</span>
                                    )}
                                </FormDataConsumer>

                                <TextField source="stage.name" label="Etapa"/>
                                <FunctionField label="Tipos" render={record => names(record.types)}/>
                                <FunctionField label="Ámbitos" render={record => names(record.scopes)}/>
                                <TextField source="term.name" label="Plazo"/>
                                <TextField source="source.name" label="Fuente"/>
                                <FunctionField label="Responsables"
                                               render={record => (record.responsibles || []).join(', ')}/>
                            </FieldGroup>
                        </Tab>
                    </TabbedShowLayout>
                </Show>
            </>
        );
    }
}

AccionShow.propTypes = {
    classes: PropTypes.shape({
        borderBottom: PropTypes.string.isRequired
    })
};

export default withStyles(styles)(translate(AccionShow));
